import { projectFirestore } from "../firebase/config";

//function to pull the list of restaurants from Firebase
export async function getResList(nameOnly= true) {
  let restaurantList = [];

  const pull = async () => {
    const docRef = projectFirestore
      .collection("restaurants")
      .where("posted", "==", true)
      .where("deleted", "!=", true)
    await docRef.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        restaurantList.push(nameOnly ? doc.data().companyName : doc.data());
      });
    });
  };

  await pull();
  return restaurantList;
}
